import React from "react";
import { MdClose, MdInfoOutline } from "react-icons/md";
import Modal from "react-modal";
import "./InfoModal.css";

const InfoModal = ({ isOpen, onClose, title, content, image }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="info-modal__content"
      style={{
        overlay: { zIndex: 1100, background: "rgba(0,0,0,0.6)" },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: 420,
          margin: 0,
          padding: 0,
          border: "none",
          borderRadius: 12,
          overflow: "hidden",
          background: "transparent",
        },
      }}
    >
      <div className="info-modal__body">
        <div className="info-modal__header">
          <div className="info-modal__header-left">
            <MdInfoOutline size={18} color="#4f46e5" />
            <span className="info-modal__title">{title}</span>
          </div>
          <button onClick={onClose} className="info-modal__close-btn">
            <MdClose size={20} />
          </button>
        </div>
        <div className="info-modal__body-content">
          {content}
          {image && (
            <div className="info-modal__image-wrapper">
              <img src={image} alt={title} className="info-modal__image" />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default InfoModal;
